export default [
    {
      path: '/admin/product-warehouse-storages',
      name: 'location-storage',
      meta: { requiresAuth: true },
      component: () => import('@/pages/product/location-storage')
    }
  ]